export class SetupMongoAtlasPrivateLinkRequest {
    'region';
    'serviceName';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "serviceName",
            "baseName": "serviceName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SetupMongoAtlasPrivateLinkRequest.attributeTypeMap;
    }
    constructor() {
    }
}
